"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmployee = void 0;
/**
 * Function to check if a customer type ID corresponds to an employee. 201 - 205 (inclusive) is the ID for employees.
 */
const isEmployee = customerTypeId => customerTypeId !== null && customerTypeId !== undefined && customerTypeId >= 201 && customerTypeId <= 205;
exports.isEmployee = isEmployee;
//# sourceMappingURL=isEmployee.js.map